import getReducer from '@admin/utils/get_reducer'

export default getReducer([
  { name: 'reload', type: 'boolean', default: false },
  { name: 'reloading', type: 'boolean', default: false },
  { name: 'revision', type: 'var', default: null }
])